import { Button, Card, Col, Row, Space, Table } from "antd";
import React from "react";
import { useTheme } from "../../../Context/ThemeContext";
import { DeleteOutlined, EyeOutlined, PlusOutlined } from "@ant-design/icons";
import Search from "antd/es/input/Search";
import { ColumnsType } from "antd/es/table";
import { useNavigate } from "react-router-dom";
import { useClient } from "../../../Context/ClientContext";

const BidsDetails = () => {
  const { themeData } = useTheme();
  const navigate = useNavigate();
  const { currentClient } = useClient();

  const dataSource = [
    {
      key: "1",
      bidName: "Mike",
      age: 32,
      address: "10 Downing Street",
    },
    {
      key: "2",
      bidName: "John",
      age: 42,
      address: "10 Downing Street",
    },
  ];

  const columns: ColumnsType<any> = [
    {
      title: "Bid Id",
      dataIndex: "bidId",
      key: "bidId",
    },

    {
      title: "Bid Name",
      dataIndex: "bidName",
      key: "bidName",
    },
    {
      title: "Bid Start Date",
      dataIndex: "bidStartDate",
      key: "bidStartDate",
    },
    {
      title: "Bid End Date",
      dataIndex: "bidEndDate",
      key: "bidEndDate",
    },
    {
      title: "Bid Applied",
      dataIndex: "bidApplied",
      key: "bidApplied",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: () => (
        <>
          <Space>
            <Button size="small" style={{ padding: "1px 5px" }}>
              <EyeOutlined />
            </Button>

            <Button style={{ padding: "1px 5px" }} size="small">
              <DeleteOutlined style={{ color: "red" }} />
            </Button>
          </Space>
        </>
      ),
    },
  ];
  return (
    <>
      <div>
        <Card
          size="small"
          className="TableCard"
          style={{
            marginTop: 10,
            boxShadow: "0px 0px 10px 0px #96A1C84D",
          }}
        >
          <Row justify={"space-between"}>
            <Col>
              <Button
                icon={<PlusOutlined />}
                onClick={() =>
                  navigate(`/inventory/clients/${currentClient?.id}/bids/add`)
                }
                type="primary"
              >
                Add Bid
              </Button>
            </Col>
            <Col>
              <Search />
            </Col>
          </Row>
          <Table
            className={`Tabel-style table-${
              themeData?.componentSize ?? "middle"
            }`}
            columns={columns}
            dataSource={dataSource}
            style={{ marginTop: "10px" }}
          />
        </Card>
      </div>
    </>
  );
};

export default BidsDetails;
